module.exports = __webpack_public_path__ + "img/static.1376fa78.png";